import { render, staticRenderFns } from "./CurationListReceiveLayout.vue?vue&type=template&id=70bf5f7a&scoped=true&"
import script from "./CurationListReceiveLayout.vue?vue&type=script&lang=js&"
export * from "./CurationListReceiveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf5f7a",
  null
  
)

export default component.exports